import companyActivationActionTypes from './action-types';

export const fetchCompanyActivationList = payload => ({
  type: companyActivationActionTypes.FETCH_COMPANY_ACTIVATION_LIST,
  payload,
});

export const fetchCompanyActivationListSuccess = payload => ({
  type: companyActivationActionTypes.FETCH_COMPANY_ACTIVATION_LIST_SUCCESS,
  payload,
});

export const fetchCompanyActivationListFail = payload => ({
  type: companyActivationActionTypes.FETCH_COMPANY_ACTIVATION_LIST_FAIL,
  payload,
});

export const fetchUpdateCompanyLicenceStatus = payload => ({
  type: companyActivationActionTypes.FETCH_UPDATE_COMPANY_LICENCE_STATUS,
  payload,
});

export const fetchUpdateCompanyLicenceStatusSuccess = payload => ({
  type: companyActivationActionTypes.FETCH_UPDATE_COMPANY_LICENCE_STATUS_SUCCESS,
  payload,
});

export const fetchUpdateCompanyLicenceStatusFail = payload => ({
  type: companyActivationActionTypes.FETCH_UPDATE_COMPANY_LICENCE_STATUS_FAIL,
  payload,
});
